/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Částečné doručení`
};

const da_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Delvis levering`
};

const de_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Teillieferung`
};

const en_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Partial delivery`
};

const es_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Entrega parcial`
};

const fr_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Livraison partielle`
};

const hu_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Részleges szállítás`
};

const it_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Consegna parziale`
};

const nl_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Gedeeltelijke levering`
};

const pl_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Częściowa dostawa`
};

const pt_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Entrega parcial`
};

const sv_order_statuses_processing_partial_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Delvis leverans`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_processing_partial_delivery = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_processing_partial_delivery(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_processing_partial_delivery", locale)
	if (locale === "cs") return cs_order_statuses_processing_partial_delivery(inputs)
	if (locale === "da") return da_order_statuses_processing_partial_delivery(inputs)
	if (locale === "de") return de_order_statuses_processing_partial_delivery(inputs)
	if (locale === "en") return en_order_statuses_processing_partial_delivery(inputs)
	if (locale === "es") return es_order_statuses_processing_partial_delivery(inputs)
	if (locale === "fr") return fr_order_statuses_processing_partial_delivery(inputs)
	if (locale === "hu") return hu_order_statuses_processing_partial_delivery(inputs)
	if (locale === "it") return it_order_statuses_processing_partial_delivery(inputs)
	if (locale === "nl") return nl_order_statuses_processing_partial_delivery(inputs)
	if (locale === "pl") return pl_order_statuses_processing_partial_delivery(inputs)
	if (locale === "pt") return pt_order_statuses_processing_partial_delivery(inputs)
	return sv_order_statuses_processing_partial_delivery(inputs)
};
export { order_statuses_processing_partial_delivery as "order_statuses.processing_partial_delivery" }